var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstantRecharge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 23,
    viewBox: "0 0 18 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7783 1.04688L1.5 13.75H7.5L6.02297 21.8702C6.02016 21.8861 6.02088 21.9024 6.02507 21.9181C6.02927 21.9337 6.03684 21.9482 6.04725 21.9606C6.05767 21.973 6.07067 21.9829 6.08535 21.9897C6.10002 21.9965 6.11601 22 6.13219 22C6.1494 22 6.16637 21.9959 6.18175 21.9882C6.19713 21.9805 6.2105 21.9693 6.22078 21.9555L16.5 9.25H10.5L11.9841 1.12891C11.9861 1.11273 11.9846 1.09631 11.9797 1.08074C11.9749 1.06518 11.9668 1.05082 11.956 1.03862C11.9452 1.02643 11.9319 1.01668 11.917 1.01002C11.9021 1.00336 11.886 0.999945 11.8697 1C11.8518 1.00007 11.8343 1.00435 11.8184 1.0125C11.8025 1.02064 11.7888 1.03242 11.7783 1.04688Z",
    stroke: "#3B82F6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstantRecharge);
export default __webpack_public_path__ + "static/media/instantRecharge.0845afd23cabf79ddc7819772820dbf6.svg";
export { ForwardRef as ReactComponent };